import { render, staticRenderFns } from "./Confirmacao.vue?vue&type=template&id=b7f542a8&scoped=true"
import script from "./Confirmacao.vue?vue&type=script&lang=js"
export * from "./Confirmacao.vue?vue&type=script&lang=js"
import style0 from "./Confirmacao.vue?vue&type=style&index=0&id=b7f542a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f542a8",
  null
  
)

export default component.exports